import MyUtil from './MyUtil';

const ConvertModule = {
  handleNew: (data) => {
    let module = {
      module_name: data.module_name,
      description: data.description,
      route_path: data.route_path,
    };

    module = MyUtil.clean(module);
    return module;
  },
  handleUpdate: (data) => {
    let module = {
      module_id: data.module_id,
      module_name: data.module_name,
      description: data.description,
      route_path: data.route_path,
    };

    module = MyUtil.clean(module);
    return module;
  },
  handleCheck: (state) => {
    const { module_name, description, route_path, isEdit } = state;
    const message = [];
    if (!module_name) message.push('module_name');
    if (!description) message.push('description');
    if (!route_path) message.push('route_path');
    return message.length > 0 ? message : false;
  },
};

export default ConvertModule;
